import React, { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import logo from "../../logo.png";
import Cookie from "js-cookie";
import { useDispatch } from "react-redux";
import { Layout, Button } from "antd";
import {
	MenuUnfoldOutlined,
	MenuFoldOutlined,
	LogoutOutlined,
} from "@ant-design/icons";

import { logout } from "../../actions/session";
import ShipperMenu from "../Menu/Shipper";
import "./Admin.scss";

export default ({ children }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const adminInfo = Cookie.get("adminInfo");
	const { Sider } = Layout;
	const [collapsed, setCollapsed] = useState(false);
	const currentUser = JSON.parse(adminInfo);
	const toggle = () => {
		setCollapsed(!collapsed);
	};

	const handleLogout = () => {
		Cookie.set("adminInfo", "");
		dispatch(logout());
		history.push("/admin");
	};

	return (
		currentUser.role === "shipper" && (
			<Layout>
				<Sider
					breakpoint="md"
					collapsedWidth="0"
					trigger={null}
					collapsible
					collapsed={collapsed}
					onBreakpoint={(broken) => {
						if (broken) setCollapsed(!collapsed);
					}}
				>
					<div className="logo-section">
						<Link to="/">
							<img src={logo} alt="logo" />
						</Link>
					</div>
					<ShipperMenu />
					<div className="menu-actions">
						{adminInfo && (
							<Button onClick={handleLogout} className="btn btn-secondary">
								Logout
								<LogoutOutlined />
							</Button>
						)}
					</div>
					{React.createElement(
						collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
						{
							className: "trigger",
							onClick: toggle,
						},
					)}
				</Sider>
				<Layout>
					<div className="content-container">{children}</div>
				</Layout>
			</Layout>
		)
	);
};
